import { useState, useEffect } from 'react';
import { IonGrid, IonRow, IonCol, IonImg } from '@ionic/react';
import { Constants } from '../../defines/Constants';
import axios from 'axios';
import './Socials.css';

const Socials = () => {
    const [socials, setSocials] = useState([]) as any;
    const socialsApi = Constants.api.socials;
    useEffect(() => {
        const getSocials = async () => {
            try {
                const results = await axios.get(socialsApi);
                if (results.status === 200) {
                    setSocials(results.data.social_items);
                }
            } catch (error: any) {
                console.log(error);
            }
        }
        getSocials();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const socialsEl = socials.map((item: any, index: number) =>
        <a href={item.link} key={"index" + index} target="_blank" rel="noreferrer">
            <IonImg src={Constants.uploads + 'socials/' + item.icon_svg} />
        </a>
    )
    return (
        <div className="socials-container">
            <IonGrid>
                <IonRow>
                    <IonCol size="12">
                        <h3 className="socials-title">ما را در فضای مجازی دنبال کنید.</h3>
                        <div className="socials-items">
                            {socialsEl}
                        </div>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </div >
    );
};
export default Socials;